var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4697 19.2371C11.5328 20.0427 7.31162 20.4459 3.01815 19.2371C1.34594 18.7665 0 17.7196 0 16.217C0 14.7008 1.39358 13.745 3.06069 13.192C6.50252 12.0498 10.337 11.9121 14.4271 13.192C16.1044 13.7167 17.4878 14.7008 17.4878 16.217C17.4878 17.7196 16.1461 18.7773 14.4697 19.2371Z",
    fill: "#62C776"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7437 10.9834C11.8444 10.9834 14.358 8.52469 14.358 5.49171C14.358 2.45872 11.8444 0 8.7437 0C5.64301 0 3.12939 2.45872 3.12939 5.49171C3.12939 8.52469 5.64301 10.9834 8.7437 10.9834Z",
    fill: "#62C776"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7288 7.20307C19.4149 6.94675 18.9542 6.99585 18.7002 7.3125L16.6073 9.92062L15.7825 9.24779C15.4583 8.98356 14.9832 9.03391 14.7211 9.36055C14.4591 9.68719 14.5093 10.1665 14.833 10.4308L16.2019 11.5476C16.2653 11.5992 16.3342 11.6383 16.4065 11.6662C16.6996 11.7914 17.0506 11.7132 17.2607 11.4515L19.8373 8.23999C20.0913 7.92334 20.0428 7.45897 19.7288 7.20265V7.20307Z",
    fill: "#62C776"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivo);
export default __webpack_public_path__ + "static/media/activo.f9b7bc7d1b4a07640d0032193b5d939f.svg";
export { ForwardRef as ReactComponent };